import React from "react";

const SkeletonAnimation = () => {
  return (
    <div className="animation-wrapper">
      <div className="animation"></div>
    </div>
  );
};

export default SkeletonAnimation;
